// // components/FilterModal.jsx

// import React from "react";
// import { Button, Modal } from "react-bootstrap";

// const FilterModal = ({
//   filter,
//   filterClose,
//   filterType,
//   SetfilterType,
//   groupedCategories,
//   countries,
//   selectedSubCategory,
//   setSelectedSubCategory,
//   setSearchCountry,
//   searchCountry,
//   getCardDetails,
//   setSelectedFilters,
//   visibleFilters = ["subject", "location", "type"], // 👈 configurable
// }) => {
//   return (
//     <Modal
//       centered
//       show={filter}
//       onHide={filterClose}
//       className="items-center m-0"
//     >
//       <div className="modalbackgroundcolor p-4 rounded-3">
//         <div className="xmark">
//           <button
//             type="button"
//             className="btn btn-close ms-auto"
//             onClick={filterClose}
//           ></button>
//         </div>

//         <dl style={{ marginTop: "20px", marginLeft: "30px" }}>
//           {/* <dt className="sortHeading">Filter by Subject</dt> */}
//           <dt className="sortHeading">
//             {visibleFilters.includes("location") &&
//             visibleFilters.includes("type")
//               ? "Filter Tutors"
//               : visibleFilters.includes("subject")
//               ? "Filter by Subject"
//               : "Filter"}
//           </dt>

//           <hr className="lines" />

//           {/* 🔄 Reset Filters */}
//           <dd
//             onClick={() => {
//               getCardDetails();
//               filterClose();
//               setSelectedSubCategory("Add a Filter");
//               setSelectedFilters({ subject: "", location: "", type: "" }); // ✅ reset all
//             }}
//             className="sortnames"
//             style={{ cursor: "pointer" }}
//           >
//             <img
//               style={{ width: "15px", height: "15px" }}
//               src={require("../../Assets/images/refresh.png")}
//               alt="Reset"
//             />
//             Reset  All Filters
//           </dd>
//           <hr className="lines" />

//           {/* Filter Buttons */}
//           <div className="flex flex-row justify-between mb-3 gap-4">
//             {visibleFilters.includes("subject") && (
//               <button
//                 onClick={() => SetfilterType("subject")}
//                 className={`w-[128px] font-semibold border-2 border-black rounded-md px-3 py-2 shadow-sm ${
//                   filterType === "subject"
//                     ? "bg-black text-white"
//                     : "bg-[#F5F3EE] text-black"
//                 }`}
//               >
//                 Subject
//               </button>
//             )}

//             {visibleFilters.includes("location") && (
//               <button
//                 onClick={() => SetfilterType("location")}
//                 className={`w-[128px] font-semibold border-2 border-black rounded-md px-3 py-2 shadow-sm ${
//                   filterType === "location"
//                     ? "bg-black text-white"
//                     : "bg-[#F5F3EE] text-black"
//                 }`}
//               >
//                 Location
//               </button>
//             )}

//             {visibleFilters.includes("type") && (
//               <button
//                 onClick={() => SetfilterType("type")}
//                 className={`w-[128px] font-semibold border-2 border-black rounded-md px-3 py-2 shadow-sm ${
//                   filterType === "type"
//                     ? "bg-black text-white"
//                     : "bg-[#F5F3EE] text-black"
//                 }`}
//               >
//                 Type
//               </button>
//             )}
//           </div>

//           <hr className="lines" />

//           {/* 🎯 Subject Filter */}

//           {/* {filterType === "subject" &&
//             visibleFilters.includes("subject") &&
//             Object.keys(groupedCategories).map((category) => (
//               <React.Fragment key={category}>
//                 <dd className="sortnames">{category}</dd>
//                 <hr className="lines" />
//                 {groupedCategories[category].map((subCategory) => (
//                   <React.Fragment key={subCategory._id}>
//                     <dd className="sortnames">
//                       <input
//                         type="radio"
//                         id={subCategory.subject}
//                         name="subCategory"
//                         value={subCategory.subject}
//                         checked={selectedSubCategory === subCategory.subject}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           setSelectedSubCategory(value);
//                           setSelectedFilters((prev) => ({
//                             ...prev,
//                             subject: value, // ✅ track subject
//                           }));
//                           getCardDetails();
//                           filterClose();
//                         }}
//                       />
//                       <label
//                         htmlFor={subCategory.subject}
//                         style={{ fontSize: "0.9rem" }}
//                       >
//                         {subCategory.subject}
//                       </label>
//                     </dd>

//                     <hr className="lines" />
//                   </React.Fragment>
//                 ))}
//               </React.Fragment>
//             ))} */}

//             {/* 🎯 Subject Filter */}
// {/* 🎯 Subject Filter */}
// {filterType === "subject" && visibleFilters.includes("subject") && (
//   <>
//     {/* 🔥 All Subjects as Radio */}
//     <dd className="sortnames">
//       <input
//         type="radio"
//         id="all-subjects"
//         name="subCategory"
//         value="All Subjects"
//         checked={selectedSubCategory === "All Subjects"}
//         onChange={() => {
//           setSelectedSubCategory("All Subjects");
//           setSelectedFilters((prev) => ({ ...prev, subject: "" })); // reset filter
//           getCardDetails();
//           filterClose();
//         }}
//       />
//       <label htmlFor="all-subjects" style={{ fontSize: "0.9rem" }}>
//         All Subjects
//       </label>
//     </dd>

//     <hr className="lines" />

//     {/* 🔽 Category wise subjects list */}
//     {Object.keys(groupedCategories).map((category) => (
//       <React.Fragment key={category}>
//         <dd className="sortnames">{category}</dd>
//         <hr className="lines" />

//         {groupedCategories[category].map((subCategory) => (
//           <React.Fragment key={subCategory._id}>
//             <dd className="sortnames">
//               <input
//                 type="radio"
//                 id={subCategory.subject}
//                 name="subCategory"
//                 value={subCategory.subject}
//                 checked={selectedSubCategory === subCategory.subject}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   setSelectedSubCategory(value);
//                   setSelectedFilters((prev) => ({ ...prev, subject: value }));
//                   getCardDetails();
//                   filterClose();
//                 }}
//               />
//               <label htmlFor={subCategory.subject} style={{ fontSize: "0.9rem" }}>
//                 {subCategory.subject}
//               </label>
//             </dd>
//             <hr className="lines" />
//           </React.Fragment>
//         ))}
//       </React.Fragment>
//     ))}
//   </>
// )}

//           {/* 🌍 Location Filter */}
//           {filterType === "location" && visibleFilters.includes("location") && (
//             <div className="max-h-[400px] overflow-y-auto pr-2 min-h-[200px]">
//               {/* Search Field */}
//               <div className="mb-2 px-1 sticky top-0 z-10">
//                 {/* <input
//                   type="text"
//                   placeholder="Search location"
//                   value={searchCountry}
//                   onChange={(e) => setSearchCountry(e.target.value)}
//                   className="serachfield w-full bg-[#EAEAEA] rounded-md pl-10 py-2 border border-transparent focus:outline-none focus:border-gray-400"
//                 /> */}
//               </div>

//               {/* Filtered Country List */}
//               {countries
//                 .filter((country) =>
//                   country.name
//                     .toLowerCase()
//                     .includes(searchCountry.toLowerCase())
//                 )
//                 .map((country) => (
//                   <React.Fragment key={country.isoCode}>
//                     <dd className="sortnames px-2">
//                       <input
//                         type="radio"
//                         id={country.name}
//                         name="country"
//                         value={country.name}
//                         checked={selectedSubCategory === country.name}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           setSelectedSubCategory(value);
//                           setSelectedFilters((prev) => ({
//                             ...prev,
//                             location: value, // ✅ track location
//                           }));
//                           getCardDetails();
//                           filterClose();
//                         }}
//                       />
//                       <label
//                         htmlFor={country.name}
//                         style={{ fontSize: "0.9rem" }}
//                       >
//                         {country.name}
//                       </label>
//                     </dd>
//                     <hr className="lines" />
//                   </React.Fragment>
//                 ))}
//             </div>
//           )}

//           {/* 👥 Type Filter */}
//           {filterType === "type" &&
//             visibleFilters.includes("type") &&
//             ["All", "AI Tutors", "Human Tutors"].map((type) => (
//               <React.Fragment key={type}>
//                 <dd className="sortnames">
//                   <input
//                     type="radio"
//                     id={type}
//                     name="tutortype"
//                     value={type}
//                     checked={selectedSubCategory === type}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       setSelectedSubCategory(value);
//                       setSelectedFilters((prev) => ({
//                         ...prev,
//                         type: value, // ✅ track type
//                       }));
//                       getCardDetails();
//                       filterClose();
//                     }}
//                   />
//                   <label htmlFor={type} style={{ fontSize: "0.9rem" }}>
//                     {type}
//                   </label>
//                 </dd>
//                 <hr className="lines" />
//               </React.Fragment>
//             ))}
//         </dl>

//         {/* <p
//           style={{
//             textAlign: "center",
//             fontFamily: "AvenirNextLTPro-Regular",
//             fontWeight: "600",
//             fontSize: "12px",
//             padding: "0px 10px",
//           }}
//         >
//           We are consistently reviewing and evolving our subject offerings...
//         </p> */}
//          <p style={{ textAlign: "center", fontWeight: "600", fontSize: "12px", padding: "0px 10px" }}>
//           {filterType === "subject" && "We are consistently reviewing and evolving our subject offerings..."}
//           {filterType === "location" && "We feature top tutors from around the world — so you can find the best fit, no matter where they’re based."}
//           {filterType === "type" && "We’re always improving our tutor experience — from expert humans to smart, culturally-aware AI."}
//         </p>
//         <hr className="lines" />
//       </div>
//     </Modal>
//   );
// };

// export default FilterModal;

// {
//   /* Filter Type Buttons */
// }
// {
//   /* <div className='flex flex-row justify-between mb-3'>
//             {visibleFilters.includes('subject') && (
//               <Button
//                 onClick={() => SetfilterType('subject')}
//                 className='subjectbutton bg-black text-white w-[128px] text-sm'
//               >
//                 Subject
//               </Button>
//             )}
//             {visibleFilters.includes('location') && (
//               <Button
//                 onClick={() => SetfilterType('location')}
//                 className='subjectbutton bg-black text-white w-[128px] text-sm'
//               >
//                 Location
//               </Button>
//             )}
//             {visibleFilters.includes('type') && (
//               <Button
//                 onClick={() => SetfilterType('type')}
//                 className='subjectbutton bg-black text-white w-[128px] text-sm'
//               >
//                 Type
//               </Button>
//             )}
//           </div> */
// }
// {
//   /* <div className='flex flex-row justify-between mb-3 gap-2'>
//             {visibleFilters.includes('subject') && (
//               <Button
//                 onClick={() => SetfilterType('subject')}
//                 variant={filterType === 'subject' ? 'dark' : 'outline-dark'}
//                 className='subjectbutton w-[128px] text-sm border border-black'
//               >
//                 Subject
//               </Button>
//             )}
//             {visibleFilters.includes('location') && (
//               <Button
//                 onClick={() => SetfilterType('location')}
//                 variant={filterType === 'location' ? 'dark' : 'outline-dark'}
//                 className='subjectbutton w-[128px] text-sm border border-black'
//               >
//                 Location
//               </Button>
//             )}
//             {visibleFilters.includes('type') && (
//               <Button
//                 onClick={() => SetfilterType('type')}
//                 variant={filterType === 'type' ? 'dark' : 'outline-dark'}
//                 className='subjectbutton w-[128px] text-sm border border-black'
//               >
//                 Type
//               </Button>
//             )}
//           </div> */
// }

// {
//   /* <div className="flex flex-row justify-between mb-3 gap-2">
//             {visibleFilters.includes("subject") && (
//               <button
//                 onClick={() => SetfilterType("subject")}
//                 className={`w-[128px] text-sm border-2 border-black rounded-md px-3 py-2 ${
//                   filterType === "subject"
//                     ? "bg-black text-white"
//                     : "bg-#F5F3EE text-black"
//                 }`}
//               >
//                 Subject
//               </button>
//             )}

//             {visibleFilters.includes("location") && (
//               <button
//                 onClick={() => SetfilterType("location")}
//                 className={`w-[128px] text-md border-2 border-black rounded-md px-3 py-2 ${
//                   filterType === "location"
//                     ? "bg-black text-white"
//                     : "bg-#F5F3EE text-black"
//                 }`}
//               >
//                 Location
//               </button>
//             )}

//             {visibleFilters.includes("type") && (
//               <button
//                 onClick={() => SetfilterType("type")}
//                 className={`w-[128px] text-md border-2 border-black rounded-md px-3 py-2 ${
//                   filterType === "type"
//                     ? "bg-black text-white"
//                     : "bg-#F5F3EE text-black"
//                 }`}
//               >
//                 Type
//               </button>
//             )}
//           </div> */
// }

// components/FilterModal.jsx

import React from 'react'
import { Modal } from 'react-bootstrap'

const FilterModal = ({
  filter,
  filterClose,
  filterType,
  SetfilterType,
  groupedCategories,
  countries,
  selectedSubCategory,
  setSelectedSubCategory,
  setSearchCountry,
  searchCountry,
  getCardDetails,
  setSelectedFilters,
  visibleFilters = ['subject', 'location', 'type'] // 👈 configurable
}) => {
  return (
    <Modal
      centered
      show={filter}
      onHide={filterClose}
      className='items-center m-0'
    >
      <div className='modalbackgroundcolor p-4 rounded-3'>
        <div className='xmark'>
          <button
            type='button'
            className='btn btn-close ms-auto'
            onClick={filterClose}
          ></button>
        </div>

        <dl style={{ marginTop: '20px', marginLeft: '30px' }}>
          <dt className='sortHeading'>
            {visibleFilters.includes('location') &&
            visibleFilters.includes('type')
              ? 'Filter Tutors'
              : visibleFilters.includes('subject')
              ? 'Filter by Subject'
              : 'Filter'}
          </dt>

          <hr className='lines' />

          {/* 🔄 Reset Filters */}
          <dd
            onClick={() => {
              getCardDetails()
              filterClose()
              setSelectedSubCategory('Add a Filter')
              setSelectedFilters({ subject: '', location: '', type: '' })
            }}
            className='sortnames'
            style={{ cursor: 'pointer' }}
          >
            <img
              style={{ width: '15px', height: '15px' }}
              src={require('../../Assets/images/refresh.png')}
              alt='Reset'
            />
            Reset All Filters
          </dd>
          <hr className='lines' />

          {/* Filter Buttons */}
          {/* <div className="flex flex-row justify-between mb-3 gap-4">
            {visibleFilters.includes("subject") && (
              <button
                onClick={() => SetfilterType("subject")}
                className={`w-[128px] font-semibold border-2  border-black rounded-md px-3 py-2 shadow-sm ${
                  filterType === "subject" ? "bg-black text-white" : "bg-[#F5F3EE] text-black"
                }`}
              >
                Subject
              </button>
            )}

            {visibleFilters.includes("location") && (
              <button
                onClick={() => SetfilterType("location")}
                className={`w-[128px] font-semibold border-2 border-black rounded-md px-3 py-2 shadow-sm ${
                  filterType === "location" ? "bg-black text-white" : "bg-[#F5F3EE] text-black"
                }`}
              >
                Location
              </button>
            )}

            {visibleFilters.includes("type") && (
              <button
                onClick={() => SetfilterType("type")}
                className={`w-[128px] font-semibold border-2 border-black rounded-md px-3 py-2 shadow-sm ${
                  filterType === "type" ? "bg-black text-white" : "bg-[#F5F3EE] text-black"
                }`}
              >
                Type
              </button>
            )}
          </div> */}
          {visibleFilters.length > 1 && (
            <div className='flex flex-row justify-between mb-3 gap-4'>
              {visibleFilters.includes('subject') && (
                <button
                  onClick={() => SetfilterType('subject')}
                  className={`w-[128px] font-semibold border-2 border-black rounded-md px-3 py-2 shadow-sm ${
                    filterType === 'subject'
                      ? 'bg-black text-white'
                      : 'bg-[#F5F3EE] text-black'
                  }`}
                >
                  Subject
                </button>
              )}

              {visibleFilters.includes('location') && (
                <button
                  onClick={() => SetfilterType('location')}
                  className={`w-[128px] font-semibold border-2 border-black rounded-md px-3 py-2 shadow-sm ${
                    filterType === 'location'
                      ? 'bg-black text-white'
                      : 'bg-[#F5F3EE] text-black'
                  }`}
                >
                  Location
                </button>
              )}

              {visibleFilters.includes('type') && (
                <button
                  onClick={() => SetfilterType('type')}
                  className={`w-[128px] font-semibold border-2 border-black rounded-md px-3 py-2 shadow-sm ${
                    filterType === 'type'
                      ? 'bg-black text-white'
                      : 'bg-[#F5F3EE] text-black'
                  }`}
                >
                  Type
                </button>
              )}
            </div>
          )}

          {/* <hr className="lines" /> */}

          {/* 🎯 SUBJECT FILTER */}
          {filterType === 'subject' && visibleFilters.includes('subject') && (
            <>
              <dd className='sortnames'>
                <input
                  type='radio'
                  id='all-subjects'
                  name='subCategory'
                  value='All Subjects'
                  checked={selectedSubCategory === 'All Subjects'}
                  onChange={() => {
                    setSelectedSubCategory('All Subjects')
                    setSelectedFilters(prev => ({ ...prev, subject: '' }))
                    getCardDetails()
                    filterClose()
                  }}
                />
                <label
                  htmlFor='all-subjects'
                  style={{
                    fontSize: '0.9rem',
                    marginTop: '10px',
                    marginBottom: '7px'
                  }}
                >
                  All Subjects
                </label>
              </dd>

              <hr className='lines' />

              {Object.keys(groupedCategories).map(category => (
                <React.Fragment key={category}>
                  <dd className='sortnames'>{category}</dd>
                  <hr className='lines' />

                  {groupedCategories[category].map(subCategory => (
                    <React.Fragment key={subCategory._id}>
                      <dd className='sortnames'>
                        <input
                          type='radio'
                          id={subCategory.subject}
                          name='subCategory'
                          value={subCategory.subject}
                          checked={selectedSubCategory === subCategory.subject}
                          onChange={e => {
                            const value = e.target.value
                            setSelectedSubCategory(value)
                            setSelectedFilters(prev => ({
                              ...prev,
                              subject: value
                            }))
                            getCardDetails()
                            filterClose()
                          }}
                        />
                        <label
                          htmlFor={subCategory.subject}
                          style={{ fontSize: '0.9rem' }}
                        >
                          {subCategory.subject}
                        </label>
                      </dd>
                      <hr className='lines ' />
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}
            </>
          )}

          {/* 🌍 LOCATION FILTER */}
          {filterType === 'location' && visibleFilters.includes('location') && (
            <>
              <dd className='sortnames'>
                <input
                  type='radio'
                  id='all-locations'
                  name='country'
                  value='All Locations'
                  checked={selectedSubCategory === 'All Locations'}
                  onChange={() => {
                    setSelectedSubCategory('All Locations')
                    setSelectedFilters(prev => ({ ...prev, location: '' }))
                    getCardDetails()
                    filterClose()
                  }}
                />
                <label
                  htmlFor='all-locations'
                  style={{
                    fontSize: '0.9rem',
                    marginTop: '10px',
                    marginBottom: '7px'
                  }}
                >
                  All Locations
                </label>
              </dd>

              <hr className='lines' />

              <div className='max-h-[400px] overflow-y-auto pr-2 min-h-[200px]'>
                {countries
                  .filter(country =>
                    country.name
                      .toLowerCase()
                      .includes(searchCountry.toLowerCase())
                  )
                  .map(country => (
                    <React.Fragment key={country.isoCode}>
                      <dd className='sortnames px-2'>
                        <input
                          type='radio'
                          id={country.name}
                          name='country'
                          value={country.name}
                          checked={selectedSubCategory === country.name}
                          onChange={e => {
                            const value = e.target.value
                            setSelectedSubCategory(value)
                            setSelectedFilters(prev => ({
                              ...prev,
                              location: value
                            }))
                            getCardDetails()
                            filterClose()
                          }}
                        />
                        <label
                          htmlFor={country.name}
                          style={{ fontSize: '0.9rem' }}
                        >
                          {country.name}
                        </label>
                      </dd>
                      <hr className='lines' />
                    </React.Fragment>
                  ))}
              </div>
            </>
          )}

          {/* 👥 TYPE FILTER */}
          {filterType === 'type' && visibleFilters.includes('type') && (
            <>
              <dd className='sortnames'>
                <input
                  type='radio'
                  id='all-tutors'
                  name='tutortype'
                  value='All Tutors'
                  checked={selectedSubCategory === 'All Tutors'}
                  onChange={() => {
                    setSelectedSubCategory('All Tutors')
                    setSelectedFilters(prev => ({ ...prev, type: '' }))
                    getCardDetails()
                    filterClose()
                  }}
                />
                <label
                  htmlFor='all-tutors'
                  style={{
                    fontSize: '0.9rem',
                    marginTop: '10px',
                    marginBottom: '7px'
                  }}
                >
                  All Tutors
                </label>
              </dd>

              <hr className='lines' />

              {['AI Tutors', 'Human Tutors'].map(type => (
                <React.Fragment key={type}>
                  <dd className='sortnames'>
                    <input
                      type='radio'
                      id={type}
                      name='tutortype'
                      value={type}
                      checked={selectedSubCategory === type}
                      onChange={e => {
                        const value = e.target.value
                        setSelectedSubCategory(value)
                        setSelectedFilters(prev => ({ ...prev, type: value }))
                        getCardDetails()
                        filterClose()
                      }}
                    />
                    <label htmlFor={type} style={{ fontSize: '0.9rem' }}>
                      {type}
                    </label>
                  </dd>
                  <hr className='lines' />
                </React.Fragment>
              ))}
            </>
          )}
        </dl>

        <p
          style={{
            textAlign: 'center',
            fontWeight: '600',
            fontSize: '12px',
            padding: '0px 10px'
          }}
        >
          {filterType === 'subject' &&
            'We are consistently reviewing and evolving our subject offerings...'}
          {filterType === 'location' &&
            'We feature top tutors from around the world — so you can find the best fit, no matter where they’re based.'}
          {filterType === 'type' &&
            'We’re always improving our tutor experience — from expert humans to smart, culturally-aware AI.'}
        </p>

        <hr className='lines' />
      </div>
    </Modal>
  )
}

export default FilterModal
